import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Edit from "../../../../assets/images/editinput.svg";
import "../../../../styles/userManagement.css";
import "../../../../styles/businessImpact.css";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import { handleNotificationSubmit } from "../../notification/notification";
import {Select} from "@appkit4/react-components/select";
import PropTypes from 'prop-types';
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp.js";
export default function EditRisk(props) {
  let {
    updateManageRiskId,
    allVendorList,
    allClassifications,
    sendBack,
    businessUsers,
  } = props;
  const [loading, setLoading] = useState(false);
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: updateManageRiskById } = useHttp();

  const dropdownData = [
    {
      value: 0.1,
      label: "0.1",
    },
    {
      value: 0.2,
      label: "0.2",
    },
    {
      value: 0.3,
      label: "0.3",
    },
    {
      value: 0.4,
      label: "0.4",
    },
    {
      value: 0.5,
      label: "0.5",
    },
    {
      value: 0.6,
      label: "0.6",
    },
    {
      value: 0.7,
      label: "0.7",
    },
    {
      value: 0.8,
      label: "0.8",
    },
    {
      value: 0.9,
      label: "0.9",
    },
    {
      value: 1,
      label: "1",
    },
  ];

 

  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    let payload = values;
    payload.status_id = updateManageRiskId.status_id;
    payload.risk_id = updateManageRiskId.risk_id;
    payload.created_by = Number(sessionStorage.getItem("userId"));
    payload.email=sessionStorage.getItem("email");
    try {
      updateManageRiskById(
        APIService.updateManageRiskById(payload),
        (result) => {
          if (result.CODE) {
            displayToastMessage(result.MSG, "success");
            setLoading(false);
            let notifData = {
              paramuserid: Number(sessionStorage.getItem("userId")),
              paramreqid: values.risk_id,
              paramcontent: "update risk request",
              paramnextroleid: 3,
              paramcreatedby: Number(sessionStorage.getItem("roleId")),
              parammsgtype: result.MSG,
            };
            handleNotificationSubmitAPI(
              APIService.handleNotificationSubmit(notifData),
              () => {}
            );
            sendBack();
            resetForm();
          } else {
            setLoading(false);
            displayToastMessage(
              "Something went wrong, Please try again!",
              "error"
            );
          }
        }
      );
    } catch (error) {
      console.log("Error", error);
      let Msg = "Action failed. Please try again!";
      displayToastMessage(Msg, "error");
    }
  };

  function formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  let validationSchema = Yup.object().shape({
    thirdPartyId: Yup.string()
      .required("Third Party Name is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    Infoclassification: Yup.string()
      .required("Information Classification is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    Servicename: Yup.string()
      .required("Service Name is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    riskOverView: Yup.string()
      .required("Over View of the Risk is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    BriefDescription: Yup.string()
      .required("Brief Description of is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    Contract: Yup.string()
      .required("Contract that cannot be Meet is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    BusinessOwner: Yup.string()
      .required("Business Owner is required")
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    controldomain: Yup.string()
      .required("Control Domain is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    controlsubdomain: Yup.string()
      .required("Control Sub Domain is required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    probabilty_occurrence: Yup.number().required(
      "Probability of Occurrence is required"
    ),
    impactBusiness: Yup.number().required("Impact to Business is required"),
    DateLogged: Yup.string().required("Date Logged is required"),
    duration: Yup.number().required("Duration is required"),
    DateIssued: Yup.string().required("Date Issued is required"),
    expirydate: Yup.string().required("Expiry Date is required"),
    Riskrating: Yup.number().required("Risk Rating is required"),
    Evidences: Yup.string().required("Evidences is required").matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ).nullable(),
    ChangeRequestType: Yup.string().required("Change Request Type is required").matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ).nullable(),
    ChangeRequest: Yup.string().required("Change Request is required").matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ).nullable(),
    Comments: Yup.string().required("Comments is required").matches(
      /^[()0-9a-zA-Z,. ]+$/,
      "Only alphabets and some special characters are allowed for this field "
    ).nullable(),
  });
  let InitialValues = {
    thirdPartyId: updateManageRiskId ? updateManageRiskId.vendor_id : "",
    Infoclassification: updateManageRiskId
      ? updateManageRiskId.information_classification
      : "",
    Servicename: updateManageRiskId ? updateManageRiskId.service_name : "",
    riskOverView: updateManageRiskId
      ? updateManageRiskId.overview_oftherisk
      : "",
    BriefDescription: updateManageRiskId
      ? updateManageRiskId.business_descriptionof_service
      : "",
    Contract: updateManageRiskId
      ? updateManageRiskId.controlthat_cannotbemet
      : "",
    BusinessOwner: updateManageRiskId ? updateManageRiskId.business_owner : "",
    controldomain: updateManageRiskId ? updateManageRiskId.risk_domain : "",
    controlsubdomain: updateManageRiskId
      ? updateManageRiskId.risk_subdomain
      : "",
    probabilty_occurrence: updateManageRiskId
      ? Number(updateManageRiskId._probabilty_occurrence)
      : "",
    impactBusiness: updateManageRiskId
      ? updateManageRiskId._impact_business
      : "",
    DateLogged: updateManageRiskId
      ? formatDate(updateManageRiskId.datelogged)
      : "",
    duration: updateManageRiskId ? updateManageRiskId.duration : 0,
    DateIssued: updateManageRiskId
      ? formatDate(updateManageRiskId.date_issued)
      : "",
    expirydate: updateManageRiskId
      ? formatDate(updateManageRiskId.expiray_date)
      : "",
    Riskrating: updateManageRiskId ? updateManageRiskId.risk_rating : 0,
    Evidences: updateManageRiskId ? updateManageRiskId.evidences : "",
    ChangeRequestType: updateManageRiskId
      ? updateManageRiskId.change_request_type
      : "",
    ChangeRequest: updateManageRiskId ? updateManageRiskId.change_request : "",
    Comments: updateManageRiskId ? updateManageRiskId.riskcomments : "",
  };

  return (
    <Formik
      initialValues={InitialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize={true}
    >
      {(prop) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
        } = prop;
        return (
          <div className="create-vendor-form-container">
            <div className="row text-right">
              <div className="col-md-12 ">
                <span className="cv-input-label mr-5">
                  Risk ID : {"RISK"}
                  {updateManageRiskId.risk_id}
                </span>
                <span className="cv-input-label mr-4">
                  Status :{" "}
                  <span className="upadte-status Close-status mr-4 status-widget">
                    {" "}
                    {updateManageRiskId._status}
                  </span>
                </span>
                <span
                  className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
                  onClick={props.sendBack}
                ></span>
              </div>
            </div>
            {loading ? (
              <div className="row" id="preloader">
                <div className="col-12 col-lg-12 loader-margin text-center">
                  <div className="a-loading a-primary a-m-10" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Third Party Name
                        <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="text"
                        value={values.thirdPartyId}
                        onChange={handleChange("thirdPartyId")}
                        name="thirdPartyId"
                      >
                        <option key="0">Select Third Party Name</option>
                        {allVendorList &&
                          allVendorList.map((each, index) => {
                            return (
                              <option key={index} value={each.vendor_id}>
                                {each.vendor_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {errors.thirdPartyId && touched.thirdPartyId && (
                      <div className="form-label error">
                        {errors.thirdPartyId}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Information Classification
                        <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="text"
                        value={values.Infoclassification}
                        onChange={handleChange("Infoclassification")}
                        name="Infoclassification"
                      >
                        <option key="0">Select Third Party Name</option>
                        {allClassifications &&
                          allClassifications.map((each, index) => {
                            return (
                              <option
                                key={index}
                                value={each.informationclassification_id}
                              >
                                {each.informationclassification_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {errors.Infoclassification &&
                      touched.Infoclassification && (
                        <div className="form-label error">
                          {errors.Infoclassification}
                        </div>
                      )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="serviceEditRisk" className="cv-input-label">
                        Service Name<span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="serviceEditRisk"
                        className="cv-input-field"
                        type="text"
                        value={values.Servicename}
                        onChange={handleChange("Servicename")}
                        name="Servicename"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.Servicename && touched.Servicename && (
                      <div className="form-label error">
                        {errors.Servicename}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="overviewEditRisk" className="cv-input-label">
                        Over View of the Risk
                        <span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="overviewEditRisk"
                        className="cv-input-field"
                        type="text"
                        onChange={handleChange("riskOverView")}
                        value={values.riskOverView}
                        name="riskOverView"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.riskOverView && touched.riskOverView && (
                      <div className="form-label error">
                        {errors.riskOverView}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="descriptionEditRisk" className="cv-input-label">
                        Brief Description of
                        <span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="descriptionEditRisk"
                        className="cv-input-field"
                        onChange={handleChange("BriefDescription")}
                        type="text"
                        value={values.BriefDescription}
                        name="BriefDescription"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.BriefDescription && touched.BriefDescription && (
                      <div className="form-label error">
                        {errors.BriefDescription}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="controlEditRisk" className="cv-input-label">
                        Control/Question
                        <span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="controlEditRisk"
                        className="cv-input-field"
                        type="text"
                        onChange={handleChange("Contract")}
                        value={values.Contract}
                        name="Contract"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.Contract && touched.Contract && (
                      <div className="form-label error">{errors.Contract}</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Business Owner
                        <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="text"
                        value={values.BusinessOwner}
                        onChange={handleChange("BusinessOwner")}
                        name="BusinessOwner"
                      >
                        <option key="0">Select Business User</option>
                        {businessUsers &&
                          businessUsers.map((each, index) => {
                            return (
                              <option key={index} value={each.user_id}>
                                {each.user_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {errors.BusinessOwner && touched.BusinessOwner && (
                      <div className="form-label error">
                        {errors.BusinessOwner}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="domainEditRisk" className="cv-input-label">
                        Domain/Area<span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="domainEditRisk"
                        className="cv-input-field"
                        onChange={handleChange("controldomain")}
                        type="text"
                        value={values.controldomain}
                        name="controldomain"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.controldomain && touched.controldomain && (
                      <div className="form-label error">
                        {errors.controldomain}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="subDomainEditRisk" className="cv-input-label">
                        Sub-Domain/Sub-Area
                        <span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="subDomainEditRisk"
                        className="cv-input-field"
                        onChange={handleChange("controlsubdomain")}
                        type="text"
                        value={values.controlsubdomain}
                        name="controlsubdomain"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.controlsubdomain && touched.controlsubdomain && (
                      <div className="form-label error">
                        {errors.controlsubdomain}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Probability of Occurrence
                        <span className="asterisk-required">*</span>
                      </label>
                      <Select
                        showSearchOnToggle={true}
                        dropdownRenderMode="portal"
                        searchable={true}
                        className="cv-input-field"
                        data={dropdownData}
                        value={values.probabilty_occurrence}
                        onSelect={(e) =>
                          handleChange("probabilty_occurrence")({
                            target: { value: e },
                          })
                        }
                        name="boarding"
                        placeholder="Select probability"
                        //disabled
                      ></Select>
                    </div>
                    {errors.probabilty_occurrence &&
                      touched.probabilty_occurrence && (
                        <div className="form-label error">
                          {errors.probabilty_occurrence}
                        </div>
                      )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="impactEditRisk" className="cv-input-label">
                        Impact to Business
                        <span className="asterisk-required">*</span>
                      </label>
                      $
                      <input
                        onBlur={handleBlur}
                        id="impactEditRisk"
                        className="cv-input-field"
                        onChange={handleChange("impactBusiness")}
                        type="text"
                        value={values.impactBusiness}
                        name="impactBusiness"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.impactBusiness && touched.impactBusiness && (
                      <div className="form-label error">
                        {errors.impactBusiness}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="dateLoggedEditRisk" className="cv-input-label">
                        Date Logged<span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="dateLoggedEditRisk"
                        className="cv-input-field"
                        type="date"
                        onChange={handleChange("DateLogged")}
                        value={values.DateLogged}
                        name="DateLogged"
                      />
                    </div>
                    {errors.DateLogged && touched.DateLogged && (
                      <div className="form-label error">
                        {errors.DateLogged}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="durationEditRisk" className="cv-input-label">
                        Duration<span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="durationEditRisk"
                        className="cv-input-field"
                        type="text"
                        onChange={handleChange("duration")}
                        value={values.duration}
                        name="duration"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                      {errors.duration && touched.duration && (
                        <div className="form-label error">
                          {errors.duration}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="dateIssuesEditRisk" className="cv-input-label">
                        Date Issued<span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="dateIssuesEditRisk"
                        className="cv-input-field"
                        type="date"
                        onChange={handleChange("DateIssued")}
                        value={values.DateIssued}
                        name="DateIssued"
                      />
                      {errors.DateIssued && touched.DateIssued && (
                        <div className="form-label error">
                          {errors.DateIssued}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="expiryDateEditRisk" className="cv-input-label">
                        Expiry Date<span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="expiryDateEditRisk"
                        className="cv-input-field"
                        type="date"
                        onChange={handleChange("expirydate")}
                        value={values.expirydate}
                        name="expirydate"
                      />
                      {errors.expirydate && touched.expirydate && (
                        <div className="form-label error">
                          {errors.expirydate}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="riskRatingEditRisk" className="cv-input-label">
                        Risk Rating<span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="riskRatingEditRisk"
                        className="cv-input-field"
                        type="text"
                        onChange={handleChange("Riskrating")}
                        value={values.Riskrating}
                        name="Riskrating"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.Riskrating && touched.Riskrating && (
                      <div className="form-label error">
                        {errors.Riskrating}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="evidencesEditRisk" className="cv-input-label">
                        Evidences<span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="evidencesEditRisk"
                        className="cv-input-field"
                        type="text"
                        onChange={handleChange("Evidences")}
                        value={values.Evidences}
                        name="Evidences"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.Evidences && touched.Evidences && (
                      <div className="form-label error">{errors.Evidences}</div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="changeEditRisk" className="cv-input-label">
                        Change Request Type
                        <span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="changeEditRisk"
                        className="cv-input-field"
                        type="text"
                        onChange={handleChange("ChangeRequestType")}
                        value={values.ChangeRequestType}
                        name="ChangeRequestType"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.ChangeRequestType && touched.ChangeRequestType && (
                      <div className="form-label error">
                        {errors.ChangeRequestType}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="requestEditRisk" className="cv-input-label">
                        Change Request
                        <span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="requestEditRisk"
                        className="cv-input-field"
                        type="text"
                        onChange={handleChange("ChangeRequest")}
                        value={values.ChangeRequest}
                        name="ChangeRequest"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.ChangeRequest && touched.ChangeRequest && (
                      <div className="form-label error">
                        {errors.ChangeRequest}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="commentsEditRisk" className="cv-input-label">
                        Comments<span className="asterisk-required">*</span>
                      </label>
                      <input
                        onBlur={handleBlur}
                        id="commentsEditRisk"
                        className="cv-input-field"
                        type="text"
                        onChange={handleChange("Comments")}
                        value={values.Comments}
                        name="Comments"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.Comments && touched.Comments && (
                      <div className="form-label error">{errors.Comments}</div>
                    )}
                  </div>
                </div>
                <div className="options-container">
                  <button
                    type="submit"
                    className="save-button "
                    disabled={isSubmitting}
                  >
                    Update
                  </button>
                  <button
                    className="cancel-button m-l-2"
                    type="reset"
                    onClick={props.sendBack}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            )}
          </div>
        );
      }}
    </Formik>
  );
}
EditRisk.propTypes = {
  updateManageRiskId: PropTypes.object,
  sendBack:PropTypes.func,
  allClassifications:PropTypes.array,
  allVendorList:PropTypes.array,
  businessUsers:PropTypes.array
 }
